<template>
  <div class="dropdown-wrapper" :class="{'dropdown-opened': isOpened}">
    <Button @click="toggleDropDown"
            class="dropdown-toggle">
            ...
    </Button>
    <div v-if="isOpened" class="dropdown-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { Component, Vue } from 'vue-property-decorator'
  import Button from '@/components/common/Button'


  @Component({
    name: 'Home',
    components: {
      Button
    }
  })

  class DropDown extends Vue {
    isOpened = false;

    toggleDropDown() {
        this.isOpened = ! this.isOpened
    }
  }
  export default DropDown
</script>

<style scoped lang="less">
.dropdown-wrapper {
  position: relative;
}

.dropdown-toggle {
  height: 30px;

  background-color: rgba(0, 0, 0, 0.07);
  border-color: transparent;
  font-weight: bold;

  &:hover {
    color: inherit;

    border-color: transparent;
    background: transparent;
    box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);
    opacity: 1;
  }
}

.dropdown-content {
  position: absolute;
  right: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  color: white;
  background-color: var(--color-bg-sidebar);
  box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.2);

  button {
    width: 100%;
    padding: 15px var(--margin--large) 15px 15px;

    color: white;
    text-align: left;

    border: 0;
    white-space: nowrap;

    &::before {
      margin-right: var(--margin--small);
    }
  }
}

.dropdown-opened {
  .dropdown-toggle {
    color: white;
    background-color: var(--color-bg-sidebar);
    border-color: var(--color-bg-sidebar);
    box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
